import React from "react";
import { formatNum } from "../flourQualityUtils";

type FarinoResult = {
  point_code: string;
  value_num?: number | null;
  value_text?: string | null;
  unit?: string | null;
};

type ExtensographResult = {
  time_min: number;
  point_code: string;
  value_1?: number | null;
  value_2?: number | null;
  mean_value?: number | null;
  unit?: string | null;
};

type AmyloResult = FarinoResult & { description?: string | null };

type Props =
  | { device: "farinograph"; results: FarinoResult[] }
  | { device: "extensograph"; results: ExtensographResult[] }
  | { device: "amylograph"; results: AmyloResult[] };

const MeasurementResultsTable = (props: Props) => {
  if (!props.results?.length) {
    return <p className="mes-hint fq-empty-results">Nema točaka mjerenja za ovaj zapis.</p>;
  }

  if (props.device === "extensograph") {
    return (
      <div className="mes-table-wrap">
        <table className="mes-table fq-results-table">
        <thead>
          <tr>
            <th>t (min)</th>
            <th>Kod</th>
            <th>V1</th>
            <th>V2</th>
            <th>Prosjek</th>
            <th>Jedinica</th>
          </tr>
        </thead>
        <tbody>
          {props.results.map((r, i) => (
            <tr key={`${r.time_min}-${r.point_code}-${i}`}>
              <td>{r.time_min}</td>
              <td><code>{r.point_code}</code></td>
              <td className="fq-num">{formatNum(r.value_1)}</td>
              <td className="fq-num">{formatNum(r.value_2)}</td>
              <td className="fq-num">{formatNum(r.mean_value)}</td>
              <td>{r.unit || "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    );
  }

  return (
    <div className="mes-table-wrap">
      <table className="mes-table fq-results-table">
      <thead>
        <tr>
          <th>Kod točke</th>
          <th>Vrijednost</th>
          <th>Tekst</th>
          <th>Jedinica</th>
          {props.device === "amylograph" && <th>Opis</th>}
        </tr>
      </thead>
      <tbody>
        {props.results.map((r, i) => (
          <tr key={`${r.point_code}-${i}`}>
            <td><code>{r.point_code}</code></td>
            <td className="fq-num">{formatNum(r.value_num)}</td>
            <td>{r.value_text || "—"}</td>
            <td>{r.unit || "—"}</td>
            {props.device === "amylograph" && <td>{(r as AmyloResult).description || "—"}</td>}
          </tr>
        ))}
      </tbody>
    </table>
    </div>
  );
};

export default MeasurementResultsTable;
